(function () {
  angular
    .module('meanApp')
    .service('authentication', ['$http', '$window','$cookies',
  function ($http, $window, $cookies) {

    var LOCAL_STORAGE_TOKEN = 'mean-token',
    COOKIE_TOKEN_NAME = 'token',
    saveToken = function (token) {
      $window.localStorage[LOCAL_STORAGE_TOKEN] = token;
    },
    getToken = function () {
      console.log('token found' +$window.localStorage[LOCAL_STORAGE_TOKEN]);
      var cookieTokenValue = $cookies.get(COOKIE_TOKEN_NAME);
      console.log('cookie retrieved is', cookieTokenValue);
      //token can be in localstorage or found as a cookie
      // is the cookie persisted over session ?
      return $window.localStorage[LOCAL_STORAGE_TOKEN] || cookieTokenValue;
    },
    removeToken = function() {
        $cookies.remove(COOKIE_TOKEN_NAME);
        $window.localStorage.removeItem(LOCAL_STORAGE_TOKEN);
    },
    isLoggedIn = function() {
      var token = getToken(),
      payload;

      if(token){
        payload = token.split('.')[1];
        payload = $window.atob(payload);
        payload = JSON.parse(payload);

        return payload.exp > Date.now() / 1000;
      } else {
        return false;
      }
    },
    getCurrentUserId = function() {
      var userId = '';
      if(isLoggedIn()){
        var token = getToken(),
        payload = token.split('.')[1];
        payload = $window.atob(payload);
        payload = JSON.parse(payload);

        userId = payload._id;
      }
      return userId;
    };

    return {
      getCurrentUserId : getCurrentUserId,
      saveToken : saveToken,
      getToken : getToken,
      isLoggedIn : isLoggedIn,
      removeToken : removeToken
    };
  }]);


})();